$(function() {
  'use strict';

  const getGraphemeLength = (text) => {
    if (window.Intl && typeof window.Intl.Segmenter === 'function') {
      const seg = new Intl.Segmenter('ja', { granularity: 'grapheme' });
      let count = 0;
      for (const _ of seg.segment(text)) count++;
      return count;
    }
    return Array.from(text.normalize('NFC')).length;
  };

  const initTextareaCharCounter = () => {
    const submitButton = $('[data-js="report-submit-button"]');
    const textareas = $('.js-report-form-char-counter');

    // フォーム内のすべてのテキストエリアの制限状態をチェックする関数
    // 複数のフォームが存在する場合、1つ目のフォームで文字数制限を超過していても
    // 2つ目のフォームで制限内の入力をすると送信ボタンが有効になってしまう問題を防ぐため、すべての状態を確認する
    const checkAllTextareas = () => {
      const hasOverLimit = Array.from(textareas).some(textarea => {
        const maxLength = textarea.dataset.maxLength;
        if (!maxLength) return false;

        const maxLengthNum = parseInt(maxLength, 10);
        const currentLength = getGraphemeLength(textarea.value);
        return currentLength > maxLengthNum;
      });

      if (submitButton.length > 0) {
        submitButton.prop('disabled', hasOverLimit);
      }
    };

    textareas.each((_, textarea) => {
      const { dataset: { showCounter, counterId, maxLength } } = textarea;

      // カウンター表示が無効な場合はスキップ
      if (showCounter !== 'true') return;

      const counter = document.getElementById(counterId);
      const maxLengthNum = isNaN(parseInt(maxLength, 10)) ? undefined : parseInt(maxLength, 10);

      // カウンター要素が見つからない場合はスキップ
      if (!counter) return;

      const updateCounter = () => {
        const currentLength = getGraphemeLength(textarea.value);
        counter.textContent = currentLength;
        const isOverLimit = maxLengthNum !== undefined && currentLength > maxLengthNum;
        $(counter).css('color', isOverLimit ? '#d1204d' : '');

        // 全テキストエリアの状態をチェック
        checkAllTextareas();
      };

      // input: リアルタイム入力時、paste: ペースト時
      // setTimeoutでペースト後のDOM更新を待つ
      $(textarea).on('input paste', () => {
        setTimeout(updateCounter, 0);
      }).trigger('input'); // 初期値設定のためトリガー
    });
  };

  initTextareaCharCounter();
});
